import React from 'react';

import PropTypes from 'prop-types';

import { emptyArray } from 'ui-components/default-props/empty';
import { StockLevelsPropType } from '../../../../../../prop-types/stock-levels';

import { InventoryService } from '../../../../../../services/inventory-service';
import { StockLevelWrapper } from './stock-level-wrapper';
import { AvailableStockLevel } from './available-stock';
import { TotalStockLevel } from './total-stock';
import { shipmentItemInventoryStatus } from '../../../../fulfillment-plan/sections/shipment-items/helpers/get-item-inventory-status';

export const MappedStockLevels = ({ itemInventoryStatus, shouldShowInventoryInfoUiTreatments = false, stockLevels = emptyArray }) => {
  const { quantity: availableQuantity } =
    stockLevels.find((stock) => stock.type === InventoryService.StockLevelQuantityType.Available) ?? {};
  const { quantity: totalQuantity } = stockLevels.find((stock) => stock.type === InventoryService.StockLevelQuantityType.Total) ?? {};
  return (
    <StockLevelWrapper>
      <AvailableStockLevel
        quantity={availableQuantity}
        shouldShowInventoryInfoUiTreatments={shouldShowInventoryInfoUiTreatments}
        status={itemInventoryStatus}
      />
      <TotalStockLevel quantity={totalQuantity} />
    </StockLevelWrapper>
  );
};

MappedStockLevels.propTypes = {
  itemInventoryStatus: PropTypes.oneOf(Object.values(shipmentItemInventoryStatus)).isRequired,
  shouldShowInventoryInfoUiTreatments: PropTypes.bool,
  stockLevels: StockLevelsPropType,
};
